import * as actionTypes from '../types/fieldsOrder';
// import { fields } from '../../components/Modal/ModalSelectFields/SelectFieldsMock';

const initialState = {
  error: false,
  fields: [],
  loading: false,
  okRequest: false,
  updateGrid: false
};

const reducer = (state = initialState, {
  type,
  payload
}) => {
  switch (type) {
    case actionTypes.GET_FIELDS_ORDER:
      return {
        ...state,
        error: false,
        fields: [],
        loading: true,
        okRequest: false
      };
    case actionTypes.GET_FIELDS_ORDER_SUCCESS:
      if (!!localStorage.getItem(`dataGrid${payload.gridName}${payload.plantType}${payload.plantId}`)) {
        let storage = JSON.parse(localStorage.getItem(`dataGrid${payload.gridName}${payload.plantType}${payload.plantId}`));
        storage = {
          ...storage,
          columns: JSON.parse(payload.settingsFile)
        };
        window.localStorage.setItem(`dataGrid${payload.gridName}${payload.plantType}${payload.plantId}`, JSON.stringify(storage));
      } else {
        window.localStorage.setItem(`dataGrid${payload.gridName}${payload.plantType}${payload.plantId}`, JSON.stringify({
          columns: JSON.parse(payload.settingsFile),
          allowedPageSizes: [10, 20, 40],
          filterPanel: { filterEnabled: true },
          filterValue: null,
          pageIndex: 0,
          pageSize: 20,
          searchText: ""
        }));
      }
      return {
        ...state,
        fields: JSON.parse(payload.settingsFile),
        loading: false,
        okRequest: true
      };
    case actionTypes.GET_FIELDS_ORDER_FAIL:
      return {
        ...state,
        error: true,
        fields: payload?.storingName
          ? JSON.parse(localStorage.getItem(payload.storingName)).columns
          : payload?.gridName ? JSON.parse(localStorage.getItem(`dataGrid${payload.gridName}${payload.plantType}${payload.plantId}`)): null,
        loading: false
      };
    case actionTypes.SAVE_FIELDS_ORDER:
      return {
        ...state,
        error: false,
        saving: true,
        okRequest: false
      };
    case actionTypes.SAVE_FIELDS_ORDER_SUCCESS:
      return {
        ...state,
        saving: false,
        okRequest: true,
        updateGrid: true
      };
    case actionTypes.SAVE_FIELDS_ORDER_FAIL:
      return {
        ...state,
        error: true,
        saving: false
      };
    case actionTypes.FIELDS_ORDER_INITIAL_STATE:
      return {
        initialState
      };
    default:
      return state;
  }
};

export default reducer;
